import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  HEADER_FILL,
  TABLE_HEADER_FILL,
  formatNumber,
  formatUnit,
  getFyLabels,
  mergeRow,
  readFY,
  safeText,
  setCell,
} from "./principle6SheetHelpers";

const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

export const SHEET_NAME = "Details of other air emissions";

const SHEET_TITLE = "Details of other air emissions";

export function buildDetailsOfOtherAirEmissionsSheet(workbook, sectionC, reportingYear = "") {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });
  const { current: fyCurrent, previous: fyPrevious } = getFyLabels(reportingYear);

  ws.getColumn("A").width = 2;
  ws.getColumn("B").width = 2;
  ws.getColumn("C").width = 2;
  ws.getColumn("D").width = 8;
  ws.getColumn("E").width = 28;
  ws.getColumn("F").width = 18;
  ws.getColumn("G").width = 16;
  ws.getColumn("H").width = 16;
  ws.getColumn("I").width = 16;

  const essential = sectionC?.principle6?.essentialIndicators || {};
  const rows = essential?.airEmissionsOthers || [];
  const dataRows = Array.isArray(rows) && rows.length ? rows : [{}];
  const airUnit = formatUnit(essential?.airEmissons?.nox?.currentUnit, "ug/m3");

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_6, { mergeEnd: COL_I });

  mergeRow(ws, TITLE_ROW, COL_D, COL_I, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr. No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Parameter", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_F, "Please specify unit", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_G, fyCurrent, { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_H, fyPrevious, { bold: true, fill: TABLE_HEADER_FILL, align: "center" });

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, safeText(item?.parameter), { align: "left" });
    setCell(ws, row, COL_F, airUnit, { align: "center" });
    setCell(ws, row, COL_G, formatNumber(readFY(item, "current")), { align: "center" });
    setCell(ws, row, COL_H, formatNumber(readFY(item, "previous")), { align: "center" });
  });

  return ws;
}
